import { motion } from "framer-motion";
import { useLanguage } from "@/lib/i18n";

const nums = ["01", "02", "03", "04"];

export default function WhyUs() {
  const { t } = useLanguage();
  const chapters = t("whyus.chapters").map((c, i) => ({ ...c, num: nums[i] }));
  return (
    <section id="why-us" className="py-32 border-t border-white/10" data-testid="why-us-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16 md:mb-24"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] mb-4" data-testid="why-us-eyebrow">
            {t("whyus.eyebrow")}
          </p>
          <h2 className="font-syne font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-none max-w-2xl" data-testid="why-us-heading">
            {t("whyus.heading")}
          </h2>
        </motion.div>

        <div>
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-white/10 items-start group"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="md:col-span-3 font-syne font-bold text-7xl md:text-8xl leading-none text-[#FF5A00]/25 group-hover:text-[#FF5A00]/60 transition-colors duration-500">
                {c.num}
              </span>
              <div className="md:col-span-9">
                <h3 className="font-syne font-bold text-2xl md:text-3xl lg:text-4xl tracking-tight">
                  {c.title}
                </h3>
                <p className="text-neutral-400 text-base md:text-lg leading-relaxed mt-4 max-w-2xl">
                  {c.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
